import { AnimatePresence, motion } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import chevronUp from '~/icons/chevron-up.svg';
import TextCard from '~/components/Dynamic/TextCard';
import SbEditable from 'storyblok-react';
import Image from '~/components/Dynamic/Image';

export default function ForCreativesSlider({content}) {

  const [selectedTab, setSelectedTab] = useState(0);
  const [clicked, setClicked] = useState(false);
  let timeout;

  useEffect(() => {

    if (!clicked) {
      timeout = setTimeout(() => {
        setSelectedTab((selectedTab + 1) === slides.length ? 0 : selectedTab + 1);
      }, 6000);
    } else {
      clearTimeout(timeout);
    }

    return () => timeout && clearTimeout(timeout);
  }, [selectedTab]);

  const slides = content[0].slides

  return (
    <section className={`my-20 md:my-28 bg-beige`}>

      <div className={`container py-20 md:py-28`}>
        <header className="flex mb-8">
          <TextCard blok={content[0]?.textCard[0]} />
        </header>
        <div className="flex flex-wrap items-center mt-0 -ml-16">
          <div className={`w-full pl-16 md:w-2/3`}>
            {slides.map((item, i) => (
              <React.Fragment key={`image${item._uid}`}>
                {selectedTab === i && (
                  <SbEditable content={item}>
                    <AnimatePresence exitBeforeEnter>
                      <motion.div
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 10, opacity: 0 }}
                      >
                        <Image blok={item.image} className="mx-auto" imageClassName="w-full lg:h-[34rem] max-auto object-contain" imgStyle={{objectFit: 'contain'}} />
                      </motion.div>
                    </AnimatePresence>
                  </SbEditable>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className={`w-full pl-16 mt-6 md:w-1/3 md:mt-0 `} onClick={() => setClicked(true)}>

            <div className={`flex gap-8 md:hidden`}>
              {slides.map((item, i) => (
                <div className="w-full py-6 mb-4 cursor-pointer" onClick={() => setSelectedTab(i)}>
                  <div className={`w-full h-0.5  bg-[#D3D2C6] relative overflow-hidden`} >
                    <div className={`absolute top-0 left-0 w-full h-full bg-blue transform -translate-x-full ${(!clicked && (selectedTab === i)) && 'animate-progress-x'} ${(clicked && (selectedTab === i)) && 'translate-x-0'}`} style={{animationDuration: '6s'}}></div>
                  </div>
                </div>
              ))}
            </div>

            {slides.map((item, i) => (
              <div key={i} className={`flex flex-col justify-center md:max-w-[24rem] pb-4 md:py-4 md:mb-2 select-none cursor-pointer ${((selectedTab !== i)) && 'hidden md:block'}`} onClick={() => setSelectedTab(i)}>
                <div className={`md:py-2 md:pl-5 relative text-center md:text-left   ${(!clicked && (selectedTab === i)) && 'border-blue'}`}>
                  <div className="hidden h-full w-0.5 bg-[#D3D2C6] md:block absolute top-1/2 transform -translate-y-1/2 left-0 overflow-hidden">
                    <div className={`absolute top-0 left-0 w-full h-full bg-blue transform -translate-y-full ${(!clicked && (selectedTab === i)) && 'animate-progress-y'} ${(clicked && (selectedTab === i)) && 'translate-y-0'}`} style={{animationDuration: '6s'}}></div>
                  </div>
                  <div className="flex flex-col">
                    <h4 className="font-extrabold uppercase text-20px u-h4">{item.textCard[0].heading}</h4>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  )
}
